import { useCallback } from "react";

import { useIntl } from "react-intl";

import CampaignLogo from "images/random/campaign.png";

import { PickingProductCard } from "./PickingProductCard";
import { useCampaignQuantites } from "../hooks/usePickingMachineSelectors";
import { usePickingStore } from "../stores/usePickingStore";

export function Campaign() {
  const intl = useIntl();

  const { picked, total } = useCampaignQuantites();
  const handleClickProductCard = useCallback(() => {
    if (picked === total) {
      return;
    }
    usePickingStore.getState().incrementCampaignQuantity();
  }, [picked, total]);

  return (
    <PickingProductCard
      itemId="itemId"
      imageUrl={CampaignLogo}
      name={intl.formatMessage({ id: "components.picking.campaign.product-card-title" })}
      pickedQuantity={picked}
      totalQuantity={total}
      hasBarcode={false}
      state={picked === total ? "DONE" : "IDLE"}
      onClickProductCard={handleClickProductCard}
    />
  );
}
